<template>
	<p>
		Siehe Punkt:
		<b>11 Aufzeichnungen des Veranstalters</b>
	</p>
</template>

<script setup lang="ts"></script>

<style scoped></style>
